// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__ICkuD","column":"style_column__M6GWx","row":"style_row__3qTLU"};